"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldControl = void 0;
var FieldControl;
(function (FieldControl) {
    FieldControl[FieldControl["TextLabel"] = 1] = "TextLabel";
    FieldControl[FieldControl["Textbox"] = 2] = "Textbox";
    FieldControl[FieldControl["EmailTextbox"] = 3] = "EmailTextbox";
    FieldControl[FieldControl["MultilineTextbox"] = 4] = "MultilineTextbox";
    FieldControl[FieldControl["Checkbox"] = 5] = "Checkbox";
    FieldControl[FieldControl["TelephoneNumberTextbox"] = 6] = "TelephoneNumberTextbox";
    FieldControl[FieldControl["RadioButtonList"] = 7] = "RadioButtonList";
    FieldControl[FieldControl["CheckboxList"] = 8] = "CheckboxList";
    FieldControl[FieldControl["Dropdown"] = 9] = "Dropdown";
    FieldControl[FieldControl["DatePicker"] = 10] = "DatePicker";
    FieldControl[FieldControl["Header1"] = 11] = "Header1";
    FieldControl[FieldControl["Header2"] = 12] = "Header2";
})(FieldControl = exports.FieldControl || (exports.FieldControl = {}));
